import { postAnalyticsMessage } from '../messages';
function isMainParent() {
    return window.parent === window;
}
export function emitAnalyticsEvent(data) {
    postAnalyticsMessage(data);
    // if we are not in an iframe, we need to return false to prevent the caller
    return !isMainParent();
}
//# sourceMappingURL=analytics.js.map